module.exports = __webpack_public_path__ + "img/Comic04-1.79551f9a.png";